import * as React from 'react';
import { observer } from 'mobx-react';
import { Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { StatusTexts } from "src/app/shared/status-texts";

interface QuoteEntryStatusConditionProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class QuoteEntryStatusCondition extends React.Component<QuoteEntryStatusConditionProps, any> {
	constructor(props) {
		super(props);

	}

	render() {

		const { values } = this.props;

		const comboValues = [
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(0), value: '0' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(1), value: '1' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(2), value: '2' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(3), value: '3' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(4), value: '4' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(5), value: '5' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(6), value: '6' },
		]
			;
		return (
			<React.Fragment>
				<div>

					<p style={{ margin: '7px' }}
					>Check if the quote entry event change status is equal before->after</p>

					<Row gutter={24}>
						<Col xs={12}>
							<DropdownView
								label='Before value'
								model={values && values["before"]}
								disabled={this.props.mode == 'display'}
								onChanged={(e) => this.props.onFieldChange("before", e.value)}
								options={comboValues}
								keyField='value'
								textField='text'
							/>
						</Col>
						<Col xs={12}>
							<DropdownView
								label='After value'
								model={values && values["after"]}
								disabled={this.props.mode == 'display'}
								onChanged={(e) => this.props.onFieldChange("after", e.value)}
								options={comboValues}
								keyField='value'
								textField='text'
							/>
						</Col>
					</Row>

				</div>



			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/conditions/quote-entry-status.condition.tsx